import React, { useCallback } from 'react';

import ExercisePreviewContainer from '@ts-core/modules/exercises/components/ExercisePreviewContainer';
import QuestionsContainer from '@ts-core/modules/exercises/components/QuestionsContainer';

import { FillInTheBlanksExercise, FillInTheBlanksQuestion } from '../../types';

import FillInTheBlanksQuestionInput from '../FillInTheBlanksQuestionInput';

interface FillInTheBlanksExerciseInputProps {
  exercise?: FillInTheBlanksExercise;
  loading?: boolean;
  onSelectOption: (option: any, questionId: string) => void;
  selectedOptions: Record<string, any>;
}

const FillInTheBlanksExerciseInput = (props: FillInTheBlanksExerciseInputProps) => {
  const { exercise, loading, onSelectOption } = props;

  const handleChangeBlank = useCallback(
    (question: FillInTheBlanksQuestion, input: Record<string, string>) => {
      const values = Object.entries(input).map(([key, value]) => ({
        _id: key,
        text: value,
      }));
      onSelectOption(values, question._id);
    },
    [onSelectOption]
  );

  return (
    <ExercisePreviewContainer exercise={exercise} layout="column">
      <QuestionsContainer
        questions={exercise?.questions}
        loading={loading}
        renderQuestion={(index, question) => (
          <FillInTheBlanksQuestionInput key={question?._id || index} question={question} loading={loading} onChangeBlank={handleChangeBlank} />
        )}
      />
    </ExercisePreviewContainer>
  );
};

export default FillInTheBlanksExerciseInput;
